import {
  faCoin, faDonate, faHome, faMoneyBill,
} from '@fortawesome/pro-light-svg-icons'

const quoteAndFinanceTabBarItems = (campaignId: number, invoiceId?: number) => [
  {
    href: `#/campaigns/${campaignId}/edit/accounting`,
    icon: faDonate,
    key: 'accounting',
    title: 'Dashboard',
  },
  {
    href: `#/campaigns/${campaignId}/edit/accounting/order-reconciliation`,
    icon: faMoneyBill,
    key: 'order-reconciliation',
    title: 'Order Reconciliation',
  },
  {
    href: `#/campaigns/${campaignId}/edit/accounting/invoices/${invoiceId}`,
    icon: faHome,
    key: 'invoices',
    title: `Invoice #${invoiceId}`,
    hidden: !invoiceId,
  },
]
export default quoteAndFinanceTabBarItems
